import { render, staticRenderFns } from "./CalendarHeader.vue?vue&type=template&id=642fa30c"
import script from "./CalendarHeader.vue?vue&type=script&lang=ts"
export * from "./CalendarHeader.vue?vue&type=script&lang=ts"
import style0 from "./CalendarHeader.vue?vue&type=style&index=0&id=642fa30c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports